import { AbstractControl, ValidationErrors, Validators } from "@angular/forms";
import { emailMaxLengthValidator, ValidationPatterns } from "@bbwt/modules/validation";

export class UserPatientValidators {
    static title = Validators.required;

    static dateOfBirth = Validators.required;

    static gender = Validators.required;

    static phoneNumber = Validators.pattern(ValidationPatterns.phone);

    static registrationNumber(isRequired: boolean) {
        return (c: AbstractControl): ValidationErrors => {
            const required = isRequired ? Validators.required(c) : null;
            const maxLength = Validators.maxLength(20)(c);

            return UserPatientValidators.combine(required, maxLength);
        };
    }

    static firstName = UserPatientValidators.requiredName;

    static lastName = UserPatientValidators.requiredName;

    static email(isRequired: boolean) {
        return (c: AbstractControl): ValidationErrors => {
            const required = isRequired ? Validators.required(c) : null;
            const valid = Validators.pattern(ValidationPatterns.email)(c);
            const maxLength = emailMaxLengthValidator(c);

            return UserPatientValidators.combine(required, valid, maxLength);
        };
    }

    static addressLine(isRequired: boolean) {
        return (c: AbstractControl): ValidationErrors => {
            const required = isRequired ? Validators.required(c) : null;
            const maxLength = Validators.maxLength(150)(c);

            return UserPatientValidators.combine(required, maxLength);
        };
    }

    static postcode(isRequired: boolean) {
        return (c: AbstractControl): ValidationErrors => {
            const required = isRequired ? Validators.required(c) : null;
            const maxLength = Validators.maxLength(8)(c);

            return UserPatientValidators.combine(required, maxLength);
        };
    }

    static participationReason = Validators.maxLength(100);

    private static requiredName(c: AbstractControl): ValidationErrors {
        const required = Validators.required(c);
        const maxLength = Validators.maxLength(35)(c);

        return UserPatientValidators.combine(required, maxLength);
    }

    private static combine(...errors: ValidationErrors[]): ValidationErrors {
        if (errors.every(e => e == null)) {
            return null;
        }

        let result = {};
        for (const error of errors.filter(e => e != null)) {
            result = Object.assign(result, error);
        }

        return result;
    }
}
